import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TDispatch } from '../../redux';
import { changeAutoProlong } from '../../redux/reducers';
import { selectIsAutoProlongChecked, selectIsAutoProlongDisabled } from '../../selectors/checkoutInfo';
import { Device } from '../common/Device';
import { AutoProlongDesktop } from './AutoProlong.desktop';
import { AutoProlongMobile } from './AutoProlong.mobile';

export const AutoProlongContainer = () => {
  const isChecked = useSelector(selectIsAutoProlongChecked);
  const isDisabled = useSelector(selectIsAutoProlongDisabled);

  const dispatch = useDispatch<TDispatch>();

  const handleChangeValue = React.useCallback(() => dispatch(changeAutoProlong(!isChecked)), [dispatch, isChecked]);

  const commonProps = {
    value: isChecked,
    isDisabled,
    onChange: handleChangeValue,
    hint: 'Публикация продлится автоматически',
  };

  return <Device mobile={<AutoProlongMobile {...commonProps} />} desktop={<AutoProlongDesktop {...commonProps} />} />;
};
